<template>
  <div
    class="fl-sym-cursor-default fl-sym-h-auto fl-sym-overflow-scroll"
    v-if="summary"
  >
    <TopHeader />
    <Indicator :priority="summary.triage_level" />
    <!-- Titles depending on priority level -->
    <div class="fl-sym-px-4">

      <div class="fl-sym-text-dark-blue fl-sym-text-xxs fl-sym-letter-space-08 fl-sym-uppercase">TRIAGE RESULT</div>
      <div class="fl-sym-text-3xl fl-sym-font-bold fl-sym-mb-6" v-if="summary.triage_level==1">
        {{ pet.name || 'Your dog'}} has <span class="fl-green">low priority</span> symptoms and requires <span class="fl-green">home care</span>.
      </div>
      <div class="fl-sym-text-3xl fl-sym-font-bold fl-sym-mb-6" v-else-if="summary.triage_level==2">
        {{ pet.name || 'Your dog'}} has <span class="fl-yellow">high priority</span> symptoms and needs to be <span class="fl-yellow">closely monitored</span>.
      </div>
      <div class="fl-sym-text-3xl fl-sym-font-bold fl-sym-mb-6" v-else-if="summary.triage_level==3">
        {{ pet.name || 'Your dog'}} requires <span class="fl-orange">urgent</span> veterinary attention within the next few hours.
      </div>
      <div class="fl-sym-text-3xl fl-sym-font-bold fl-sym-mb-6" v-else>
        Strongly recommended to seek <span class="fl-red">emergency </span> veterinary attention.
      </div>
      <div class="fl-sym-text-lg fl-sym-text-intermediate fl-sym-mt-10 fl-sym-mb-4">What do you need to do?</div>
    </div>
    <!-- Section 1 -->
    <!--Only shows Map on High priority, Urgent and Emergency -->
    <div class="fl-sym-px-4" v-if="summary.triage_level!=1">
      <div class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-py-1">
        <h3 class="fl-sym-mt-2 fl-sym-p-3 fl-sym-text-phd fl-sym-text-base fl-sym-font-bold"
        >1. Contact your veterinarian or the nearest veterinary clinic.</h3>
        <div class="fl-sym-rounded-lg google-maps fl-sym-shadow-lg">
          <Map/>
        </div>

        <div class="fl-sym-text-right map-button">
        <img src="@/assets/current-location-icon.svg" width="10" class="fl-sym-inline fl-sym-mr-1"/>
        <div
          class="fl-sym-text-right fl-my-location fl-sym-mb-2 fl-sym-inline fl-sym-text-xs fl-sym-font-normal fl-sym-text-dark-blue"
        >Current Location</div>
          </div>
      </div>
    </div>
    <!-- Show Monitor only on Low priority-->
    <div class="fl-sym-px-4">

      <div id="monitor" class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-mb-5" v-if="summary.triage_level==1">
        <h3 class="fl-sym-mt-2 fl-sym-p-lr-3 fl-sym-p-t-3 fl-sym-text-phd fl-sym-text-base">
          <span class="fl-sym-font-bold">1. Monitor your pet's symptoms over the next few days.</span> Look out for any of these worsening symptoms:</h3>
        <div class="fl-sym-p-lr-3 fl-sym-p-b-3">
          <ul>
            <li v-if="summary.monitor">{{summary.monitor}}</li>
            <li v-if="summary.homecare">{{summary.homecare}}</li>
          </ul>
        </div>
      </div>
      <!-- End of Section 1 -->
      <!-- Section 2 -->
      <!--Home Care only on Low priority -->

      <div class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-mb-5" v-if="summary.triage_level==1">
        <h3 class="fl-sym-mt-2 fl-sym-p-lr-3 fl-sym-p-t-3 fl-sym-text-phd fl-sym-text-base fl-sym-font-bold">
          2. We recommend the following home care:</h3>
        <div class="fl-sym-p-lr-3 fl-sym-p-b-3">
          <ul>
            <li v-if="summary.homecare">{{summary.homecare}}</li>
            <li v-if="summary.monitor">{{summary.monitor}}</li>
          </ul>
        </div>
      </div>
      <!--Contact clinic and pets symptoms only on high priority, urgent and emergency -->

      <div class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-mb-5" v-else>
        <h3 class="fl-sym-mt-2 fl-sym-p-3 fl-sym-text-phd fl-sym-text-base fl-sym-font-bold">
          2. Contact the clinic and inform them of your pet's symptoms.</h3>
        <div class="fl-sym-m-4 fl-sym-flex fl-sym-flex-wrap symptoms">
          <button class="fl-sym-text-center fl-sym-light-gray fl-sym-border-2 fl-sym-border-intermediate fl-sym-px-2 fl-sym-rounded-full fl-sym-p-1 fl-sym-mb-2 fl-sym-mr-1 fl-sym-text-xs" v-for="symptom in summary.summary" :key="symptom">{{symptom}}</button>
        </div>
      </div>

      <!-- End of Section 2 -->
      <!-- Section 3 -->
      <!-- Consulting step 3 on low priority-->

      <div class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-mb-5" v-if="summary.triage_level==1">
        <h3 class="fl-sym-mt-2 fl-sym-p-3 fl-sym-text-phd fl-sym-text-base"><span class="fl-sym-font-bold">3. If your pet's symptoms start to worsen or you have any questions,
        </span>Please contact your veterinarian or use <a class="fl-blue fl-sym-font-bold" href="#">our online consulting service</a>.</h3>
      </div>
      <!-- Monitor worsen symptoms high priority and urgent-->
      <div class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-mb-5" v-else-if="summary.triage_level==2 || summary.triage_level==3">
        <h3 class="fl-sym-mt-2 fl-sym-p-t-3 fl-sym-p-lr-3 fl-sym-text-phd fl-sym-text-base ">
          <span class="fl-sym-font-bold"> 3. Follow the veterinarian's advice.</span>
          We recommend that you monitor your pet
          <span class="fl-sym-underline">closely</span> for the next 12 hours. Look out for any of these worsening symptoms:
          <p></p>
         </h3>
        <div class="fl-sym-p-lr-3 fl-sym-p-b-3 my-2 fl-sym-mt-4">
          <div class="italic">
            <div class="fl-sym-antialiased fl-sym-italic" v-if="summary.monitor">{{summary.monitor}}</div>
            <div class="fl-sym-italic" v-if="summary.homecare != summary.monitor">{{summary.homecare}}</div>
          </div>
        </div>
      </div>
      <!-- Bring to vet immediately on Emergency-->

      <div class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-mb-5" v-else>
        <h3 class="fl-sym-mt-2 fl-sym-p-3 fl-sym-text-phd fl-sym-text-base fl-sym-font-bold">3. Bring your pet to the veterinary clinic immediately.</h3>
      </div>

      <!-- End of Section 3 -->
      <!-- Section 4 -->
      <!-- Contact Vet step 4 on high-->
      <div class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-mb-5" v-if="summary.triage_level==2">
        <h3 class="fl-sym-mt-2 fl-sym-p-3 fl-sym-text-phd fl-sym-text-base"><span class="fl-sym-font-bold">4. If your pet's symptoms start to worsen or you have any questions,
        </span>please contact your veterinarian or use <a class="fl-blue fl-sym-font-bold" href="#">our online consulting service</a>.</h3>
      </div>
      <!-- Consulting step 4 on urgent-->
      <div class="fl-sym-rounded-20 fl-sym-bg-light-gray fl-sym-mb-5" v-if="summary.triage_level==3">
        <h3 class="fl-sym-mt-2 fl-sym-p-3 fl-sym-text-phd fl-sym-text-base fl-sym-font-bold">
          4. If your pet’s symptoms start to worsen, bring them to the nearest veterinary clinic <span class="fl-red">immediately</span>.</h3>
      </div>

      <!-- End of Section 4 -->



     <div class="fl-sym-px-4" v-if="isLoggedIn" @click="onReturn">
       <button  type="submit" class="button-blue-gradient fl-sym-letter-space-064 fl-sym-font-semibold hover:fl-sym-text-opacity-75 fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm">Save my pet's history</button>
     </div>
      <div class="fl-sym-px-4" v-else @click="next">
    <button  type="submit" class="button-blue-gradient fl-sym-letter-space-064 fl-sym-font-semibold hover:fl-sym-text-opacity-75 fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm">Start a new symptom check</button>
     </div>

      <div class="fl-sym-text-dark-blue fl-sym-cursor-pointer fl-sym-letter-space-064 fl-sym-font-semibold fl-sym-flex fl-sym-justify-center fl-sym-mt-2">

        <div class="link" @click="onBack">Back</div>
      </div>
    </div>
  </div>
</template>
<style>
li {
  list-style: inside;
}
::marker {
  font-size: small;
}
.google-maps {
  width: 90%;
  margin: 10px auto 5px auto;
  border-radius: 20px;
  box-shadow: 0px 3px 6px #0000004D;
}
.fl-sym-rounded-20 {
  border-radius: 20px;
}
.map-button {
  margin-right: 1.75rem;
  margin-bottom: 0.75rem;
}
</style>
<script>
import TopHeader from "@/components/headerNav/TopHeader.vue"
import Indicator from "@/components/indicator.vue"
import Map from "@/components/map/map.vue"
import { mapState } from "vuex"
export default {
  components: {
    TopHeader,
    Indicator,
    Map
  },
  computed: {
    ...mapState({
      summary: (state) => state.sc.summary,
      isLoggedIn: (state) => state.auth.token !== "",
      pet: (state) => state.pet,
    }),
  },
  async mounted() {
    this.$store.dispatch("sc/summary")
  },
  props: {
    priority: {
      default: 1,
      type: Number,
    },
  },
  methods: {
    rotate() {},
    async onBack() {
      await this.$store.dispatch("sc/presummary")
    },
    next() {
      this.$router.push({ name: process.env.VUE_APP_RT_HOME })
    },
    onReturn() {
      this.$router.push({ name: process.env.VUE_APP_DASHBOARD })
    },
  },
}
</script>
